import { Box, Flex } from '@volue/wave-react';
import React from 'react';

import type { ScenarioName } from '@/features/execute-calculation-set/overmind/calculation/domain/ScenarioId';

export function LoadFlowDetailsHeader(props: { scenarioName?: ScenarioName }) {
  return (
    <span
      data-component={LoadFlowDetailsHeader.name}
      style={{ display: 'contents' }}
    >
      <Flex justifyContent={'space-between'}>
        <Box css={{ color: '$colorAccent70', fontWeight: 'bolder' }}>
          {'LoadFlow'}
        </Box>
        <Box css={{ color: '$colorAccent70', fontWeight: 'bolder' }}>
          {props.scenarioName && `Scenario: ${props.scenarioName}`}
        </Box>
      </Flex>
    </span>
  );
}
